const chroma = require('chroma-js')

const getScale = (
	colorString = chroma.random().hex(),
	mode = 'rgb',
	steps = 10,
	correctLightness = true
) => {
	if (!chroma.valid(colorString)) return

	const color = chroma(colorString)

	const colorDark = color.darken(3).hex()
	const colorLight = color.brighten(3.7).desaturate(1).hex()

	let scale = chroma.scale([colorDark, color, colorLight]).mode(mode)

	if (correctLightness) {
		scale = scale.correctLightness()
	}

	scale = scale.colors(steps)

	const revScale = scale
	revScale.reverse()

	return revScale
}

export { getScale }
